import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { Dialog } from "primereact/dialog";
import Langs from "../../app/lang/langs";
import { InputField } from "../../components/inputs/InputField";
import { AssetsPannel } from "../../components/inputs/AssetsPannel";

export default function ViewMissionModal(props) {

    const isMobile = useSelector((state) => state.settings.isMobile)
    const visibleFields = [
        { key: "team_name", type: "string", disabled: true },
        { key: "poste_name", type: "string", disabled: true },
        { key: "start_date", type: "date", disabled: true },
        { key: "end_date", type: "date", disabled: true }
    ]

    useEffect(() => {
    }, [props])

    return (
        <Dialog
            visible={props.selectedMission}
            style={{ width: isMobile === 2 ? "90%" : "50%" }}
            onHide={() => {
                props.onHide()
            }}
            header={<Langs str="VIEW_MISSION" />}
            draggable={false}
            dismissableMask={false}
        >
            {visibleFields.map(field =>
                <InputField field={field}
                    value={props.selectedMission && props.selectedMission[field.key]} />
            )}
            <AssetsPannel
                tableName='team_members'
                idParent={props.selectedMission?.id_mission}
                assets={props.selectedMission?.assets}
                uploadCallBackFunction={() => { }}
                deleteCallBackFunction={() => { }}
                label="Assets"
                readOnly={true}
                //parentSetter={setOnGoingMission}
            />
        </Dialog>
    )
}